import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './App.css';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import Agenda from './pages/Agenda';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import Servicos from './pages/Servicos';
import Receita from './pages/Receita';
import Despesa from './pages/Despesa';
import Relatorios from './pages/Relatorios';
import Usuarios from './pages/Usuarios';
import CrmClientes from './pages/CrmClientes';
import Logs from './pages/Logs';
import Configuracoes from './pages/Configuracoes';
import { SiteHome } from './site/SiteHome';
import { SiteScheduling } from './site/SiteScheduling';

const resolveInitialView = () => {
  const path = window.location.pathname.toLowerCase();
  const hash = window.location.hash.toLowerCase();
  if (path.includes('agendamento') || hash.includes('agendamento')) {
    return 'agendamento';
  }
  if (path.includes('erp') || path.includes('painel') || path.includes('dashboard') || path.includes('login') || hash.includes('erp') || hash.includes('login')) {
    return localStorage.getItem('erp_token') ? 'erp' : 'login';
  }
  return 'site';
};

function App() {
  const [view, setView] = useState(resolveInitialView);
  const [selectedServiceId, setSelectedServiceId] = useState(null);
  const [erpPage, setErpPage] = useState('dashboard');
  const [usuario, setUsuario] = useState(() => localStorage.getItem('erp_usuario') || null);
  const [isAdmin, setIsAdmin] = useState(() => localStorage.getItem('erp_login') === 'admin');

  const handleLogout = () => {
    localStorage.removeItem('erp_token');
    localStorage.removeItem('erp_usuario');
    localStorage.removeItem('erp_login');
    delete axios.defaults.headers.common.Authorization;
    setUsuario(null);
    setIsAdmin(false);
    setView('site');
  };

  useEffect(() => {
    const onSessionExpired = () => {
      localStorage.removeItem('erp_token');
      localStorage.removeItem('erp_usuario');
      localStorage.removeItem('erp_login');
      delete axios.defaults.headers.common.Authorization;
      setUsuario(null);
      setIsAdmin(false);
      setView('site');
    };

    window.addEventListener('erp:session-expired', onSessionExpired);
    return () => window.removeEventListener('erp:session-expired', onSessionExpired);
  }, []);

  const handleLogin = (nomeUsuario) => {
    setUsuario(nomeUsuario);
    setIsAdmin(localStorage.getItem('erp_login') === 'admin');
    setView('erp');
    setErpPage('dashboard');
  };

  const handleNavigate = (targetView, extra = {}) => {
    if (extra?.serviceId) {
      setSelectedServiceId(extra.serviceId);
    }
    if (targetView === 'erp' && !usuario) {
      setView('login');
      return;
    }
    setView(targetView);
  };

  // 1. Site da Fran (Página Inicial Pública)
  if (view === 'site') {
    return <SiteHome onNavigate={handleNavigate} usuario={usuario} />;
  }

  // 2. Agendamento Online Público
  if (view === 'agendamento') {
    return (
      <SiteScheduling
        onNavigate={handleNavigate}
        initialServiceId={selectedServiceId}
        usuario={usuario}
      />
    );
  }

  // 3. Login do ERP
  if (view === 'login' || (!usuario && view === 'erp')) {
    return (
      <Login
        onLogin={handleLogin}
        onBackToSite={() => handleNavigate('site')}
      />
    );
  }

  // 4. Painel de Gestão ERP
  const renderErpPage = () => {
    switch (erpPage) {
      case 'agenda':     return <Agenda />;
      case 'clientes':   return <Clientes />;
      case 'servicos':   return <Servicos />;
      case 'receita':    return <Receita />;
      case 'despesa':    return <Despesa />;
      case 'relatorios':    return <Relatorios />;
      case 'crm':           return <CrmClientes />;
      case 'configuracoes': return <Configuracoes />;
      case 'logs':          return <Logs />;
      case 'usuarios':      return isAdmin ? <Usuarios /> : <Dashboard />;
      default:           return <Dashboard />;
    }
  };

  return (
    <div className="app-container">
      <Sidebar
        currentPage={erpPage}
        setCurrentPage={setErpPage}
        usuario={usuario}
        isAdmin={isAdmin}
        onLogout={handleLogout}
        onViewSite={() => handleNavigate('site')}
      />
      <main className="main-content">
        {renderErpPage()}
      </main>
    </div>
  );
}

export default App;
